import { AxiosPromise } from 'axios';
import request from '@/utils/request';

import { FcCoinsQuery, FifaCoinsAppVo } from './type';

/**
 * 查询符合条件的fifa金币包列表
  GET /product/api/fifa/coins/list
  接口ID：235194322
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-235194322
 */
export const getCoinsList = (params: FcCoinsQuery): AxiosPromise<FifaCoinsAppVo> => {
  return request({
    url: '/product/api/fifa/coins/list',
    method: 'get',
    params
  });
};

/**
 * 查询是否是首次购买fifia金币
  GET /api/order/buyer/fifacoin/first
  接口ID：275231421
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-275231421
 */
export const getFcFirstPurchase = (): AxiosPromise<boolean> => {
  return request({
    url: '/api/order/buyer/fifacoin/first',
    method: 'get'
  });
};
